import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { skopaPlatformFormOptions } from "../shared";

const platformTypeOptions = [
  { label: "Battleship", value: "BATTLESHIP" },
  { label: "Destroyer", value: "DESTROYER" },
  { label: "Frigate", value: "FRIGATE" },
  { label: "Submarine", value: "SUBMARINE" },
  { label: "Aircraft Carrier", value: "AIRCRAFT_CARRIER" },
  { label: "Military Helicopter", value: "MILITARY_HELICOPTER" },
  { label: "Fighter Jet", value: "FIGHTER_JET" },
  { label: "Bomber", value: "BOMBER" },
  { label: "Drone", value: "DRONE" },
  { label: "Mobile Truck", value: "MOBILE_TRUCK" },
  { label: "Armored Vehicle", value: "ARMORED_VEHICLE" },
  { label: "Tank", value: "TANK" },
  { label: "Missile Launcher", value: "MISSILE_LAUNCHER" },
  { label: "Static Installation", value: "STATIC_INSTALLATION" },
  { label: "Satellite", value: "SATELLITE" },
  { label: "Other", value: "OTHER" },
];

export const PlatformBlock = withForm({
  ...skopaPlatformFormOptions,
  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend>New Skopa platforms</FieldLegend>
        <FieldDescription>
          This is a short description describing the form
        </FieldDescription>

        <FieldGroup>
          <Field orientation="horizontal">
            <Field>
              <form.AppField name="name">
                {(field) => <field.TextField label="Platform name" />}
              </form.AppField>
            </Field>

            <Field></Field>
          </Field>
          <Field orientation="horizontal">
            <Field>
              <form.AppField name="platformId">
                {(field) => <field.TextField label="Platform ID" />}
              </form.AppField>
            </Field>
            <Field>
              <form.AppField name="type">
                {(field) => {
                  return (
                    <field.SelectField
                      fieldLabel="Type"
                      list={platformTypeOptions}
                    />
                  );
                }}
              </form.AppField>
            </Field>
          </Field>
        </FieldGroup>
      </FieldSet>
    );
  },
});
